import { isAfter } from 'date-fns'
import { Checkpointable } from '../sagas/createCheckpoints'

export const getMostRecent = (items: Checkpointable[]): Checkpointable =>
  items.reduce<Checkpointable>((currentMostRecent, currentItem) => {
    if (
      isAfter(
        currentItem.checkpointableDate,
        currentMostRecent.checkpointableDate
      )
    ) {
      return currentItem
    }
    if (
      isAfter(
        currentMostRecent.checkpointableDate,
        currentItem.checkpointableDate
      )
    ) {
      return currentMostRecent
    }
    // if timestamps are identical, the entity with the highest id is the most recent
    if (currentItem.id > currentMostRecent.id) {
      return currentItem
    }
    return currentMostRecent
  }, items[0])

export const getMostRecentId = (items: Checkpointable[]): string => {
  const mostRecentItem = getMostRecent(items)
  return mostRecentItem.id.toString()
}

export const getMostRecentDateString = (items: Checkpointable[]): string => {
  const mostRecentItem = getMostRecent(items)
  return mostRecentItem.checkpointableDate.toISOString()
}
